import React from 'react'
import { HeroIcons } from '../../lib/utils/heroIcons'

interface ClubAccessVisualProps {
  t: (key: string) => string
}

export default function ClubAccessVisual({ t }: ClubAccessVisualProps) {
  return (
    <div className="relative flex h-full min-h-[320px] w-full flex-col overflow-hidden bg-gray-950 p-5 text-white sm:p-6 md:min-h-[460px]">
      <div className="absolute inset-0 bg-walkthrough-pattern bg-cover bg-center opacity-30" />
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-gray-950 to-transparent" />
      <img
        src="/img/icons/3d/thiings/house-key.png"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute left-6 top-1 z-0 h-auto w-24 rotate-3 object-contain opacity-65 drop-shadow-xl sm:left-8 sm:top-2 sm:w-28"
      />

      <div className="relative z-10 flex justify-end">
        <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1 text-xs font-medium text-white backdrop-blur">
          <HeroIcons.LockClosedIcon className="h-4 w-4" />
          {t('requestInvitation.visualBadge')}
        </div>
      </div>

      <div className="relative z-10 grid flex-1 content-center gap-3 pt-5 sm:grid-cols-3 md:grid-cols-1">
        <div className="rounded-md border border-white/10 bg-white/10 p-4 backdrop-blur">
          <div className="mb-2 flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-950">
            <HeroIcons.UserGroupIcon className="h-5 w-5" />
          </div>
          <p className="text-sm font-semibold">
            {t('requestInvitation.highlights.eligibility.title')}
          </p>
          <p className="mt-1 text-xs leading-5 text-gray-300">
            {t('requestInvitation.highlights.eligibility.text')}
          </p>
        </div>
        <div className="rounded-md border border-white/10 bg-white/10 p-4 backdrop-blur">
          <div className="mb-2 flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-950">
            <HeroIcons.DocumentTextIcon className="h-5 w-5" />
          </div>
          <p className="text-sm font-semibold">
            {t('requestInvitation.highlights.access.title')}
          </p>
          <p className="mt-1 text-xs leading-5 text-gray-300">
            {t('requestInvitation.highlights.access.text')}
          </p>
        </div>
        <div className="rounded-md border border-white/10 bg-white/10 p-4 backdrop-blur">
          <div className="mb-2 flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-950">
            <HeroIcons.CursorArrowRaysIcon className="h-5 w-5" />
          </div>
          <p className="text-sm font-semibold">
            {t('requestInvitation.highlights.intent.title')}
          </p>
          <p className="mt-1 text-xs leading-5 text-gray-300">
            {t('requestInvitation.highlights.intent.text')}
          </p>
        </div>
      </div>
    </div>
  )
}
